import React, { useState, useEffect } from "react";
import CustomBox from "../../CustomComponents/CustomBox/CustomBox";
import CustomPaper from "../../CustomComponents/CustomPaper/CustomPaper";
import CustomCard from "../../CustomComponents/CustomCard/CustomCard";
import CustomTypography from "../../CustomComponents/CustomTypography/CustomTypography";
import CustomCardContent from "../../CustomComponents/CustomCardContent/CustomCardContent";
import CustomButton from "../../CustomComponents/CustomButton/CustomButton";
import { useStyles } from "../../../assets/jss/ContentDetails";
import { updateContent } from "../../../services/ContentDetails";
import ErrorAlert from "../../ErrorAlert/ErrorAlert";
import CustomDivider from "../../CustomComponents/CustomDivider/CustomDivider";
import { ActionStatus, RBAC_CODE } from "../../../config/app-globals.enum";
import { getUserRBAC } from "../../../services/LocalStorageService";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function TextComponent(props:any) {
    const params = useParams();

    const { t } = useTranslation();
    const classes = useStyles();
    const [getRBAC_ContentView] = React.useState(
        getUserRBAC(RBAC_CODE.CONTENT_VIEW, props)
    );
    const [isBtnEnabled, setIsBtnEnabled] = React.useState(false);
    const [content, setContent] = useState(null);
    const [isApiFailed, setIsApiFailed] = useState(false);
    const [isApi, setIsApi] = useState(false);
    const [isContentCompleted, setIsContentCompleted] = useState(false);
    const [mobileTokenParam] = useState(props.mobileTokenParam);
    const [finishNoteTitle, setFinishNoteTitle] = useState(null);
    const [finishNote, setFinishNote] = useState(null);

    useEffect(() => {
        if (props.content) {
            setContent(props.content);
        }
    }, [props.content]);

    const [statusValue, setStatusValue] = React.useState();
    const [alertMessage, setAlertMessage] = React.useState("");
    const [isAlertOpen, setIsAlertOpen] = React.useState(false);

    const changeApiStatusCodeFunc = (status) => {
        if (status.code && status.code !== 0 && status.code !== 200) {
            setStatusValue(status.code);
            setAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsAlertOpen(true);
        }
    };

    const updateContentProgress = async (isFinish) => {
        if (content && content.actionStatus !== ActionStatus.COMPLETED) {
            setIsApi(true);
            setAlertMessage("");
            setIsAlertOpen(false);
            const data = await updateContent({
                contentId: content._id,
                contentTypeId: content.contentTypeId,
                contentCompletedPercentage: 100,
                isFinish: isFinish,
                mobileToken: mobileTokenParam,
            }, params);
            if (
                data &&
                (data.status.code === 0 ||
                    data.status.code === 200 ||
                    data.status.code === 201)
            ) {
                setIsApi(false);
                setIsApiFailed(false);
                setIsContentCompleted(true);
                if (isFinish) {
                    setFinishNoteTitle(
                        data.content.finishNoteTitle ? data.content.finishNoteTitle : null
                    );
                    setFinishNote(
                        data.content.finishNote ? data.content.finishNote : null
                    );
                }
            } else {
                setIsApi(false);
                setIsApiFailed(true);
                changeApiStatusCodeFunc(data.status);
            }
        }
    };

    setInterval(() => setIsBtnEnabled(true), 5000);

    return (
        <>
            <CustomPaper elevation={0}>
                <CustomCard elevation={0} className={classes.cardContentWrapper}>
                    <CustomCardContent className={classes.cardContent}>
                        {content && !isContentCompleted && (
                            <>
                                <CustomBox className={classes.cardContentBody}>
                                    {content.title && (
                                        <CustomTypography
                                            component="h3"
                                            variant="h3"
                                            className={classes.headerTitle}
                                        >
                                            {content.title}
                                        </CustomTypography>
                                    )}
                                    {content.content && (
                                        <CustomBox
                                            dangerouslySetInnerHTML={{ __html: content.content }}
                                        />
                                    )}
                                </CustomBox>
                                {/* getRBAC_ContentView &&
                    getRBAC_ContentView.isUpdate === 1 */}
                                {content.actionStatus !== ActionStatus.COMPLETED &&
                                    content.actionStatus !== ActionStatus.EXPIRED ? (
                                    <>
                                        <CustomDivider className={classes.spacer} />
                                        <CustomBox
                                            className={classes.cardContentFooter}
                                            mt={0}
                                            mb={2}
                                        >
                                            <CustomTypography
                                                className={classes.actionLabel}
                                                component="h5"
                                                variant="h5"
                                            >
                                                {t("PLEASE_CLICK_ON_THE_SUBMIT_BUTTON_TO_MARK_THIS_CONTENT_AS_COMPLETE")}
                                            </CustomTypography>
                                            <CustomButton
                                                variant="contained"
                                                color="primary"
                                                className={classes.primaryButtonXl}
                                                disabled={!isBtnEnabled}
                                                defaultrounded="true"
                                                onClick={() => updateContentProgress(true)}
                                            >
                                                {t("SUBMIT")}
                                            </CustomButton>
                                        </CustomBox>
                                    </>
                                ) : null}
                            </>
                        )}
                        {/* @Todo: Need to add completion message */}
                        {isContentCompleted && (
                            <>
                                <CustomBox className={classes.cardContentBody}>
                                    <CustomBox className={classes.completeMessage}>
                                        {finishNoteTitle && (
                                            <CustomTypography
                                                component="h5"
                                                className={classes.completeMessageTitle}
                                                dangerouslySetInnerHTML={{
                                                    __html: finishNoteTitle,
                                                }}
                                            />
                                        )}
                                        {finishNote && (
                                            <CustomTypography
                                                component="p"
                                                className={classes.completeMessageDesc}
                                                dangerouslySetInnerHTML={{
                                                    __html: finishNote,
                                                }}
                                            />
                                        )}
                                    </CustomBox>
                                </CustomBox>
                            </>
                        )}
                    </CustomCardContent>
                </CustomCard>
            </CustomPaper>
            <ErrorAlert
                code={statusValue}
                message={alertMessage}
                isOpen={isAlertOpen}
                isClose={(isClose) => setIsAlertOpen(!isClose)}
            />
        </>
    );
}
